import * as React from "react";
import { Form, FormGroup, Button, CustomInput, Row, Col } from "reactstrap";
import * as endpoints from "../constants/endpoints";
import Cookies from "universal-cookie";
import { toast } from "react-toastify";
import Table from "../Table";
import _ from "lodash";
import styled from "styled-components";
import loader from "../../images/spinner.gif";
import i18next from "i18next";
const cookies = new Cookies();

class DeleteSalesRows extends React.PureComponent<DeleteSalesRows> {
  state = {
    fileTypeToUpload: 1,
    fileToUpload: "",
    historyLogs: {
      page: 1,
      itemsPerPage: 20,
      orderBy: "", // name
      orderDirection: "", // asc
      totalSize: null,
      data: [],
      isLoading: false,
    },
    historyFilters: {},
    showOverlayLoader: false,
  };

  constructor(props) {
    super(props);
    this.paginationUpdated = this.paginationUpdated.bind(this);
  }

  componentDidMount() {
    this.toggleImportDeletionFileBtnState(true);
    this.GetLoadDataHistory();
  }

  GetLoadDataHistory = () => {
    const url =
      endpoints.DISTRIBUTOR_DISTRIBUTOR_SALES + "/GetDeletedSalesHistory";
    fetch(url, {
      method: "post",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json-patch+json",
        Authorization: `Bearer ${cookies.get("rawtoken")}`,
      },
      body: JSON.stringify({
        page: this.state.historyLogs.page - 1,
        pageSize: this.state.historyLogs.itemsPerPage,
        orderBy: this.state.historyLogs.orderBy,
        orderDirection: this.state.historyLogs.orderDirection,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        const historyLogs = { ...this.state.historyLogs };

        res.data.forEach((item) => {
          const dateArray = item.dateCreated.split("T");
          const date = new Date(dateArray[0]).toLocaleDateString("en-GB");
          const time = dateArray[1];
          item.dateCreated = `${date} at ${time.split(".")[0]}`;
        });

        historyLogs.totalSize = res.dataTotalSize;
        historyLogs.data = res.data;
        historyLogs.isLoading = false;
        this.setState({ historyLogs: historyLogs });
      });
    _.set(this.state, "dataErrors.itemsPerPage", 5);
  };

  getHistoryLogsSettings = () => {
    return {
      tableColumns: [
        {
          key: "fileName",
          title: i18next.t("file_name"),
          isFilterable: false,
          sortable: false,
        },
        {
          key: "recordsCount",
          title: i18next.t("count_rows"),
          isFilterable: false,
          sortable: false,
        },
        {
          key: "dateCreated",
          title: i18next.t("upload_date"),
          isFilterable: false,
          sortable: false,
        },
      ],
      tableCells: ["fileName", "recordsCount", "dateCreated"],
      searchSuccess: true,
      dateCreated: "0001-01-01T00:00:00",
      dateUpdated: "0001-01-01T00:00:00",
    };
  };

  paginationUpdated(itemsPerTable, currentPage) {
    const historyLogs = this.state.historyLogs;
    historyLogs.itemsPerPage = itemsPerTable;
    historyLogs.page = currentPage;

    this.setState({ historyLogs }, () => {
      this.GetLoadDataHistory();
    });
  }

  UploadFile = (event) => {
    event.preventDefault();
    this.setState({ showOverlayLoader: true });

    if (this.state.fileToUpload !== null && this.state.fileToUpload !== "") {
      const url =
        endpoints.DISTRIBUTOR_DISTRIBUTOR_SALES + "/DeleteSpecificSales";
      const file = this.state.fileToUpload;
      let data = new FormData();
      data.append("file", file);

      return fetch(url, {
        method: "delete",
        body: data,
        headers: {
          Authorization: `Bearer ${cookies.get("rawtoken")}`,
        },
      }).then((response) => {
        this.setState({ showOverlayLoader: false });
        if (response.status >= 200 && response.status < 300) {
          toast.success("Success");
        } else {
          toast.error("Error");
        }
        this.GetLoadDataHistory();
      });
    }
  };

  toggleImportDeletionFileBtnState = (state) => {
    var deleteDtrSales = document.getElementById("importDeletionFileBtn");
    if (deleteDtrSales) {
      (deleteDtrSales as HTMLInputElement).disabled = state;
    }
  };

  public render() {
    const LoaderWrapper = styled.div`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: fixed;
      min-height: 300px;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.15);
      z-index: 12;
    `;
    return (
      <>
        <Form onSubmit={(event) => this.UploadFile(event)}>
          <FormGroup>
            <Row>
              <Col md={{ size: 3, offset: 0 }}>
                <CustomInput
                  className="mb-3"
                  type="file"
                  id="fileUpload"
                  label={i18next.t("file")}
                  onChange={(e) => {
                    this.setState({ fileToUpload: e.target.files[0] });
                    this.toggleImportDeletionFileBtnState(false);
                  }}
                />
                <Button
                  type="submit"
                  id="importDeletionFileBtn"
                  color="danger"
                  className="w-100"
                >
                  {i18next.t("import_deletion_file")}
                </Button>
              </Col>
            </Row>
          </FormGroup>
        </Form>
        <Table
          type="history_log"
          title={i18next.t("history_log")}
          tableSettings={this.getHistoryLogsSettings()}
          data={this.state.historyLogs.data}
          allowMultipleSelection={false}
          paginationUpdated={this.paginationUpdated}
          emitSelectedIds={() => null}
          totalItems={
            this.state.historyLogs.totalSize
              ? this.state.historyLogs.totalSize
              : 0
          }
          currentPage={this.state.historyLogs.page}
          itemsPerPage={this.state.historyLogs.itemsPerPage}
          isLoading={this.state.historyLogs.isLoading}
          selectedRows={[]}
          filters={this.state.historyFilters}
          currentSortingDirection={this.state.historyLogs.orderDirection}
          hideFilters={true}
          hideExport={true}
          hideSearch={true}
          hideFooter={false}
        />
        {this.state.showOverlayLoader === true && (
          <LoaderWrapper>
            <p>{i18next.t("uploading")}</p>
            <img src={loader} alt="" />
          </LoaderWrapper>
        )}
      </>
    );
  }
}

export default DeleteSalesRows;
